<div class="luggageTooltip__cont">
  <app-ds-background-surface
    class="luggageTooltip__cont__surface"
    [type]="backgroundSurface"
    [height]="'auto'"
    [width]="'auto'"
    [borderRadius]="'var(--border-radius-nano)'"
    [padding]="'var(--spacing-xxxs) var(--spacing-xxxs)'">
    <div class="luggageTooltip__cont__luggage-info">
      <div class="luggageTooltip__cont__luggage-info__title">
        <app-ds-typography
          [size]="xsFontSize"
          [fontFamily]="semiBoldFontFamily"
          [color]="primaryTypographyColor"
          [text]="'LUGGAGE_MODULE.LUGGAGE' | transloco">
        </app-ds-typography>
      </div>
      <div class="luggageTooltip__cont__luggage-info__item">
        <app-ds-icon
          [icon]="backpack"
          [size]="16"
          [color]="getIconColor(!disableBackpackLuggage)">
        </app-ds-icon>
        <app-ds-typography
          class="luggageTooltip__cont__luggage-info__description"
          [size]="xxxsFontSize"
          [tag]="'p'"
          [color]="getTypographyColor(!disableBackpackLuggage)"
          [text]="backpackLuggageText | transloco">
        </app-ds-typography>
      </div>
      <div class="luggageTooltip__cont__luggage-info__divider">
        <app-ds-divider></app-ds-divider>
      </div>
      <div class="luggageTooltip__cont__luggage-info__item">
        <app-ds-icon
          [icon]="handLuggage"
          [size]="16"
          [color]="getIconColor(handBaggage)">
        </app-ds-icon>
        <app-ds-typography
          class="luggageTooltip__cont__luggage-info__description"
          [size]="xxxsFontSize"
          [tag]="'p'"
          [color]="getTypographyColor(handBaggage)"
          [text]="includesHandBaggageText | transloco">
        </app-ds-typography>
      </div>
      <div class="luggageTooltip__cont__luggage-info__divider">
        <app-ds-divider></app-ds-divider>
      </div>
      <div class="luggageTooltip__cont__luggage-info__item">
        <app-ds-icon
          [icon]="luggage"
          [size]="16"
          [color]="getIconColor(includesLuggageWarehouse)">
        </app-ds-icon>
        <app-ds-typography
          class="luggageTooltip__cont__luggage-info__description"
          [size]="xxxsFontSize"
          [tag]="'p'"
          [color]="getTypographyColor(includesLuggageWarehouse)"
          [text]="warehouseTitle | transloco">
        </app-ds-typography>
      </div>
      <div class="luggageTooltip__cont__luggage-info__subtitle">
        <app-ds-typography
          [size]="xxxsFontSize"
          [tag]="'p'"
          [color]="subtitleColor"
          [text]="warehouseSubtitle | transloco: { baggage: baggage }">
        </app-ds-typography>
      </div>
    </div>
  </app-ds-background-surface>
</div>
